import React, { Component } from 'react';
import { connect } from 'react-redux';
import { find, findIndex, includes, isEqual, isNil } from 'lodash';
import withRouter from '../../lib/router/withRouter';
import HomeWidgetListWrap from '../../views/widget/home/widget/list/HomeWidgetListWrap';
import { widgetActions } from '../../store/modules/widget';
import { asyncSimpleModal, checkIsNonSelectedList } from '../../lib/common';
import { INVALID_REQUIRED_SELECT_WIDGET_MESSAGE } from '../../constants/service/invalidMsg/widgetInvalidMsg';
import { setDateFormat } from '../../lib/moment';
import { DATE_FORMAT } from '../../constants/service/common/utilConstants';
import { HOME_TYPE, WIDGET_EXPOSURE_TYPE, WIDGET_STATUS } from '../../constants/service/app/widgetConstants';
import { WIDGET_SEARCH_KEYWORD } from '../../store/modules/widget/models';
import { _LIST_PAGINATION_MODEL } from '../../store/modules/app/models';

class HomeWidgetListContainer extends Component {
  /**
   *  위젯 리스트 저장하기
   */
  saveWidgetList = async () => {
    const confirmResult = await asyncSimpleModal({
      type: 'confirm',
      title: '노출 중인 위젯 저장',
      message: '정말로 저장을 하시겠습니까?',
    });

    if (!confirmResult) return;

    const { homeType, pageWidgetList, saveUpdatedWidgetList } = this.props;
    const { widgetList, originalWidgetList, widgetPageInfo } = pageWidgetList;

    let updatedPageWidgetList = widgetList.list;

    /**
     *  서버에 보낼 때는 id, no, status, exposureStartDate, exposureEndDate 만 넘겨줌.
     *  위젯 상태가 활성(1)인 경우에만 순서가 부여됨
     */
    let widgetNumber = 0;
    updatedPageWidgetList = updatedPageWidgetList
      .filter((item) => !item.isHomeMenu)
      .map((item) => ({
        id: item.id,
        no: item.status === WIDGET_STATUS.ACTIVE ? ++widgetNumber : null,
        exposureStartDate: item.exposureStartDate
          ? setDateFormat(item.exposureStartDate, DATE_FORMAT.FULL_DASH_FORMAT)
          : null,
        exposureEndDate: item.exposureEndDate
          ? setDateFormat(item.exposureEndDate, DATE_FORMAT.FULL_DASH_FORMAT)
          : null,
        status: item.status,
      }));

    // 메인 페이지의 첫번째 기획전 위젯이 변경이 되었을 경우에는 이전의 기획전 위젯을 비활성처리 함
    if (
      homeType === HOME_TYPE.MAIN &&
      originalWidgetList[0] &&
      updatedPageWidgetList[0] &&
      originalWidgetList[0].id !== updatedPageWidgetList[0].id
    ) {
      updatedPageWidgetList.push({
        ...originalWidgetList[0],
        status: WIDGET_STATUS.INACTIVE,
      });
    }

    saveUpdatedWidgetList({
      homeType,
      homeId: widgetPageInfo.id,
      pageWidgetList: updatedPageWidgetList,
    });
  };

  /**
   * 위젯 노출기간 일괄 변경하기
   */
  onChangeBulkWidgetPeriod = (widgetExposureType) => {
    const { pageWidgetList, setData } = this.props;
    const { widgetList, selectedWidgetIdList, originalWidgetList, widgetExposurePeriodBatchInfo } = pageWidgetList;

    const targetSelectedWidgetIdList = selectedWidgetIdList.filter((id) => id);

    /**
     * 선택된 위젯이 있는지 체크
     */
    const isSelected = checkIsNonSelectedList(targetSelectedWidgetIdList, INVALID_REQUIRED_SELECT_WIDGET_MESSAGE);
    if (!isSelected) return;

    /**
     *  변경할 위젯 노출 기간
     */
    let targetWidgetExposureDate = {};

    /**
     *  직접 설정
     */
    if (widgetExposureType === WIDGET_EXPOSURE_TYPE.DIRECT_SETTING) {
      targetWidgetExposureDate = {
        exposureStartDate: setDateFormat(widgetExposurePeriodBatchInfo.startDate, DATE_FORMAT.FULL_DASH_FORMAT),
        exposureEndDate: setDateFormat(widgetExposurePeriodBatchInfo.endDate, DATE_FORMAT.FULL_DASH_FORMAT),
      };
    } else if (widgetExposureType === WIDGET_EXPOSURE_TYPE.INFINITE) {
      /**
       *  무기한
       */
      targetWidgetExposureDate = {
        exposureStartDate: null,
        exposureEndDate: null,
      };
    }

    const updatedPageWidgetList = widgetList.list.map((widget) => {
      if (includes(targetSelectedWidgetIdList, widget.id)) {
        const targetWidget = find(originalWidgetList, (original) => original.id === widget.id);
        const isEdit =
          !targetWidget ||
          !isEqual(targetWidgetExposureDate, {
            exposureStartDate: targetWidget.exposureStartDate,
            exposureEndDate: targetWidget.exposureEndDate,
          });
        return {
          ...widget,
          ...targetWidgetExposureDate,
          isEdit,
        };
      }
      return widget;
    });

    setData({
      path: ['pageWidgetList', 'widgetList', 'list'],
      value: updatedPageWidgetList,
    });
  };

  /**
   * 위젯 상태 변경하기
   */
  onChangeWidgetStatus = (data) => {
    const { widgetId, index, status } = data;
    const { setData, pageWidgetList } = this.props;
    const { originalWidgetList } = pageWidgetList;
    const targetWidget = find(originalWidgetList, (original) => original.id === widgetId);

    setData({
      path: ['pageWidgetList', 'widgetList', 'list', index, 'status'],
      value: status,
    });
    setData({
      path: ['pageWidgetList', 'widgetList', 'list', index, 'isEdit'],
      value: !targetWidget || targetWidget.status !== status,
    });
  };

  /**
   * 위젯 순서 변경하기
   */
  onChangeWidgetNo = (newList) => {
    const { setData, pageWidgetList } = this.props;
    const { originalWidgetList } = pageWidgetList;
    const updatedList = newList.map((widget, index) => {
      const originIndex = findIndex(originalWidgetList, (original) => original.id === widget.id);
      const isEdit = isNil(originIndex) || originIndex !== index;
      return {
        ...widget,
        isEdit,
      };
    });
    setData({
      path: ['pageWidgetList', 'widgetList', 'list'],
      value: updatedList,
    });
  };

  /**
   *  기간에 따른 위젯 미리보기
   */
  widgetPreviewCompare = async () => {
    const { pageWidgetList, getWidgetPreviewCompareData } = this.props;
    const { widgetList } = pageWidgetList;

    if (!widgetList.list.length) {
      await asyncSimpleModal({
        type: 'error',
        title: '위젯 미리보기',
        message: '위젯을 먼저 추가해주세요.',
      });
      return;
    }

    /**
     *  업데이트 후의 위젯 id 리스트
     */
    const targetPageWidgetList = widgetList.list.filter(
      (item) => !item.isHomeMenu && item.status === WIDGET_STATUS.ACTIVE,
    );

    /**
     *  업데이트하기 전의 위젯 미리보기 데이터와
     *  업데이트 후의 미리보기 데이터 가져오기
     */
    getWidgetPreviewCompareData({
      pageWidgetList: targetPageWidgetList,
    });
  };

  /**
   *  비활성 위젯 리스트 가져오기
   */
  getInactiveWidgetList = () => {
    const { toggleModal, pageWidgetList, homeType } = this.props;
    const { widgetList } = pageWidgetList;

    toggleModal({
      name: 'searchInactiveWidgetModal',
      value: true,
      data: {
        homeType,
        list: [],
        searchOption: {
          searchKeyword: WIDGET_SEARCH_KEYWORD,
        },
        pagination: _LIST_PAGINATION_MODEL,
        excludeWidgetIdList: widgetList.list.filter((item) => !item.isHomeMenu).map((item) => item.id),
        isProductRecommend: !location.pathname.includes('/sub/'),
      },
    });
  };

  render() {
    const { homeType, pageWidgetList, getList, setData, getWidgetPreviewData } = this.props;

    return (
      <HomeWidgetListWrap
        homeType={homeType}
        pageWidgetList={pageWidgetList}
        setData={setData}
        getList={getList}
        saveWidgetList={this.saveWidgetList}
        onChangeBulkWidgetPeriod={this.onChangeBulkWidgetPeriod}
        onChangeWidgetStatus={this.onChangeWidgetStatus}
        onChangeWidgetNo={this.onChangeWidgetNo}
        getWidgetPreviewData={getWidgetPreviewData}
        getInactiveWidgetList={this.getInactiveWidgetList}
        widgetPreviewCompare={this.widgetPreviewCompare}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    pageWidgetList: state.widget.pageWidgetList,
  };
};

const mapDispatchToProps = {
  setData: widgetActions.setData,
  saveUpdatedWidgetList: widgetActions.saveUpdatedWidgetList,
  getWidgetPreviewData: widgetActions.getWidgetPreviewData,
  getWidgetPreviewCompareData: widgetActions.getWidgetPreviewCompareData,
  toggleModal: widgetActions.toggleModal,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(HomeWidgetListContainer));
